import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { MessageSquare, Phone, ArrowRight } from "lucide-react";
import { useSettings } from "../../lib/useSettings";
import { track } from "../../lib/api";

export default function CTASection() {
  const { settings: s } = useSettings();
  return (
    <section className="relative bg-[color:var(--brand-navy)] text-white overflow-hidden" data-testid="cta-section">
      {/* Ambient glow accents */}
      <div
        className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full opacity-30 pointer-events-none"
        style={{ background: "radial-gradient(circle, var(--brand-sky), transparent 65%)" }}
      />
      <div
        className="absolute -bottom-40 -left-40 w-[400px] h-[400px] rounded-full opacity-15 pointer-events-none"
        style={{ background: "radial-gradient(circle, var(--brand-red), transparent 65%)" }}
      />
      <div className="relative max-w-6xl mx-auto px-4 md:px-8 py-20 md:py-28">
        <div className="grid md:grid-cols-3 gap-10 md:gap-12 items-center">
          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.25em] text-[color:var(--brand-sky)] font-semibold mb-3">
              Passez à l'action
            </div>
            <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-black leading-[1.05] tracking-tight">
              Devis gratuit sous 24h,<br />
              <span className="brand-gradient-text">sans engagement.</span>
            </h2>
            <p className="mt-5 text-white/75 text-base md:text-lg max-w-xl leading-relaxed">
              Particuliers, professionnels et entreprises — étude personnalisée, déplacement offert sur les Bouches-du-Rhône. Chaque projet mérite un vrai diagnostic.
            </p>
            <div className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-white/60 uppercase tracking-wider font-semibold">
              <span className="flex items-center gap-1.5"><span className="w-1 h-1 rounded-full bg-[color:var(--brand-sky)]" />Réponse 24h</span>
              <span className="flex items-center gap-1.5"><span className="w-1 h-1 rounded-full bg-[color:var(--brand-sky)]" />100% gratuit</span>
              <span className="flex items-center gap-1.5"><span className="w-1 h-1 rounded-full bg-[color:var(--brand-sky)]" />Sans engagement</span>
              <span className="flex items-center gap-1.5"><span className="w-1 h-1 rounded-full bg-[color:var(--brand-sky)]" />10 ans d'expérience</span>
            </div>
          </div>
          <div className="flex flex-col gap-3">
            <Link to="/devis" data-testid="cta-devis-btn">
              <Button size="lg" className="w-full rounded-full bg-[color:var(--brand-sky)] hover:bg-[color:var(--brand-sky)]/90 text-white font-bold h-12 gap-2 group">
                <MessageSquare className="w-4 h-4" /> Demander un devis
                <ArrowRight className="w-4 h-4 ml-auto group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
            {s?.phone && (
              <a href={`tel:${s.phone.replace(/\s/g, "")}`} onClick={() => track("tel_click", { meta: { location: "cta" } })} data-testid="cta-phone-btn">
                <Button size="lg" variant="outline" className="w-full rounded-full bg-transparent border-white/30 text-white hover:bg-white hover:text-[color:var(--brand-navy)] font-bold h-12 gap-2">
                  <Phone className="w-4 h-4" /> {s.phone}
                </Button>
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
